import { useParams } from 'react-router';
import { CatalogRequestState } from '../catalog/CatalogRequestState';
import { FileContextForm } from './FileContextForm';
import { useFileContext, useFileEntities } from './useFileContexts';
import '../catalog/catalogEditor.css';
import './fileContexts.css';

export function FileContextEditorPage() {
  const params = useParams();
  const id = params.contextId === undefined ? undefined : Number(params.contextId);
  const isValid = id === undefined || (Number.isSafeInteger(id) && id > 0);
  const context = useFileContext(isValid ? id : undefined);
  const entities = useFileEntities();
  const error = !isValid ? 'Некорректный адрес страницы.' : context.error?.message || entities.error?.message;
  const isLoading = entities.isPending || (id !== undefined && context.isPending);
  return <section className="admin-page catalog-workspace">
    {error || isLoading ? <CatalogRequestState error={error} onRetry={() => { void context.refetch(); void entities.refetch(); }} /> : <FileContextForm key={id ?? 'new'} context={context.data} entities={entities.data ?? []} />}
  </section>;
}
